const globalRestrictions = job =>
       !job.verified
    || (job.reportLevel > 1 && !job.stcHasTechnicalPossibility);
const isReleasedForReportLevel = job =>
       job.reportLevel > 2
    && job.status.jobReleased !== 'FULFILLED';

export const QuestionSectionNames = {
  RECEIVED_PRODUCT: 'received-product',
  PRODUCT_EVALUATION: 'product-evaluation',
  STRIP_OBSERVATION: 'strip-observation',
  TECHNICAL_INVESTIGATION: 'technical-investigation',
  CONFORMITY_TEST: 'conformity-test'
}

export const sections = [
  {
    name: 'receivedProduct',
    formName: QuestionSectionNames.RECEIVED_PRODUCT,
    isLocked: job => globalRestrictions(job),
  },
  {
    name: 'productEvaluation',
    formName: QuestionSectionNames.PRODUCT_EVALUATION,
    isLocked: job =>
      globalRestrictions(job)
      || job.reportLevel < 2
      || isReleasedForReportLevel(job),
  },
  {
    name: 'stripObservation',
    formName: QuestionSectionNames.STRIP_OBSERVATION,
    isLocked: job =>
      globalRestrictions(job)
      || job.testAssessment === "Pass (No strip required)"
      || job.testAssessment === "Fail (No strip required)"
      || job.testAssessment === "Pass"
      || isReleasedForReportLevel(job),
  },
  {
    name: 'technicalInvestigation',
    formName: QuestionSectionNames.TECHNICAL_INVESTIGATION,
    isLocked: job =>
      globalRestrictions(job)
      || job.reportLevel < 3
      || isReleasedForReportLevel(job),
  },
  {
    name: 'conformityTest',
    formName: QuestionSectionNames.CONFORMITY_TEST,
    isLocked: job =>
      globalRestrictions(job)
      || job.testAssessment === "Pass"
      || isReleasedForReportLevel(job),
  },
];



// WEBPACK FOOTER //
// ./src/views/SingleJob/constants.js